/**
 * React component for rendering the web version of the Matic footer.
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.data - Data for rendering the footer.
 * @returns {JSX.Element} The rendered FooterMaticWeb component.
 */

import React, { useCallback, useRef, useState, useEffect } from "react";
import Image from "next/image";
import { motion, useInView, useAnimation } from "framer-motion";
import ZigZag from "../../../assets/svg/ZigZagIcon";
import maticImage from "@assets/images/footer/web.webp";
import movingRobot from "@assets/images/homepage/matic_moving_top.webp";

const transitionTimer = { duration: 3, ease: "easeInOut", delay: 1 };

export default function FooterMaticWeb({ data }) {
  const ref = useRef();
  // const inView = useInView(ref, { once: true, amount: 0.2 });
  const robotInView = useInView(ref, { once: true, amount: 1 });

  const controls = useAnimation();
  const finalTransformX = "calc(100% + 110px)";

  useEffect(() => {
    if (robotInView) {
      controls.start({ x: finalTransformX });
    }
  }, [robotInView]);

  return (
    <div className="w-[100%] relative overflow-hidden" ref={ref}>
      <div className="aspect-w-1440 aspect-h-504">
        <div className="h-full w-full">
          <div className="h-full relative">
            <div className="w-full absolute">
              <div className="aspect-w-1440 aspect-h-504">
                <Image
                  src={maticImage}
                  alt="Dirt Image Web"
                  className="bg-primary"
                  layout="fill"
                />
              </div>
            </div>
            <div className={`w-[12.7%] absolute right-[3%] top-[66%]`}>
              <div className="aspect-w-183 aspect-h-158">
                <motion.div
                  initial={{ x: "0%" }}
                  animate={controls}
                  transition={transitionTimer}
                >
                  <Image
                    src={movingRobot}
                    layout="fill"
                    alt="Moving Robot"
                  />
                  <span className="bg-lavender py-2 px-3 flex items-center w-max rounded-[10px] gap-2 absolute bottom-[50%] origin-left -rotate-90 left-[25%]">
                    <ZigZag color="#1F2022" strokeWidth="1" />
                    <span className="uppercase font-medium small-p font-trimMono">
                      Vacuuming
                    </span>
                  </span>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
